import { FC } from 'react';

export const MODAL_NAMESPACE: string = 'modal';

export interface IModalContentProps {
    handleModalClose?: () => void;
}

export interface IModalState {
    modalComponent: FC<IModalContentProps> | null;
    onOpenFunction: (() => void) | null;
    onCloseFunction: (() => void) | null;
    hideMask: boolean;
}
